import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { deleteInventory } from '../Api'

export default generateApiAction({
  baseType: Types.INVENTORIES.DELETE,
  api: deleteInventory,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/inventories/DeleteAction.js